import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import { ColDef, ICellRendererParams } from "ag-grid-enterprise";
import { ActionIcon, Group } from "@mantine/core";
import { FaPlus } from "react-icons/fa";
import DeviceIcon from "../../../SelectedSpace/DeviceIcon";
import { AgGridReact } from "ag-grid-react";
import { ICompareItem } from "./standardRoomCompareUtils";
import { IDevice, IMcBimItem } from "@backend/src/schemas";
import { addDeviceTypeToSelectedRoomThunk } from "../../../DesignTab/devices/deviceThunks";
import { selectHttpGetDeviceTypes } from "../../../DesignTab/deviceTypesSelectors";

export const StandardRoomCompareTable: React.FC<{
  compareItems: ICompareItem[];
  mcbimItemsInStandardSpace: IMcBimItem[];
  devices: IDevice[];
}> = ({ compareItems }) => {
  const dispatch = useAppDispatch();

  const deviceTypes = useAppSelector(selectHttpGetDeviceTypes);

  const add = (compcode: string | undefined) => {
    const deviceType = deviceTypes.find((dt) => dt.compCode === compcode);
    if (deviceType) {
      dispatch(addDeviceTypeToSelectedRoomThunk(deviceType));
    }
  };

  const columns: ColDef<ICompareItem>[] = [
    {
      headerName: "",
      width: 75,
      cellRenderer: (params: ICellRendererParams<ICompareItem>) => {
        return (
          <ActionIcon onClick={() => add(params.data?.compCode ?? "")} size="xs">
            <FaPlus />
          </ActionIcon>
        );
      },
    },
    {
      field: "deviceType",
      hide: true,
      sort: "desc",
    },
    {
      field: "diff",
      headerName: "Diff",
      hide: true,
    },
    {
      field: "compDescription",
      hide: true,
      sort: "desc",
    },
    {
      field: "compCode",
      headerName: "CompCode",
      width: 150,
      cellRenderer: (params: ICellRendererParams<ICompareItem>) => {
        const textColor = params.data?.diff === 0 ? "green" : "red";
        return (
          <Group>
            <DeviceIcon deviceType={params.data?.deviceType} />
            <span style={{ color: textColor }}>{params.value ?? "-"}</span>
          </Group>
        );
      },
    },
    {
      field: "countInStdRom",
      headerName: "Antall i standardrom",
      width: 150,
    },
    {
      field: "countInRoom",
      headerName: "Antall i rom",
      width: 150,
    },
  ];

  return (
    <div className="ag-theme-quartz" style={{ overflow: "auto", height: "100%", width: "100%" }}>
      <AgGridReact columnDefs={columns} rowData={compareItems} />
    </div>
  );
};
